<div id="mainDev">
    <router-outlet></router-outlet>
</div>

<app-loader></app-loader>

<div class="rl-toast-host" *ngIf="rlToast as toast" role="status" aria-live="polite">
  <div class="rl-toast" [ngClass]="'rl-toast-' + toast.type">
    <span class="rl-toast-icon" aria-hidden="true">
      <span class="material-symbols-outlined">
        {{ toast.type === 'success' ? 'check' : (toast.type === 'warning' ? 'warning' : (toast.type === 'info' ? 'info' : 'help')) }}
      </span>
    </span>
    <p class="rl-toast-text">{{ toast.text }}</p>
  </div>
</div>

<div class="modal fade" id="confirm" tabindex="-1" aria-labelledby="networkStatusTitle" aria-hidden="true"
  data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content rl-alert-content">
      <div class="rl-alert-body">
        <div class="rl-alert-icon" [class.is-offline]="alertKind === 'offline'" [class.is-online]="alertKind === 'online'"
          aria-hidden="true">
          <span class="material-symbols-outlined">{{ alertKind === 'offline' ? 'wifi_off' : 'check_circle' }}</span>
        </div>
        <h3 class="rl-alert-title" id="networkStatusTitle">{{ alertTitle }}</h3>
        <p class="rl-alert-text">{{ msgText }}</p>
      </div>
      <div class="rl-alert-actions">
        <button type="button" class="rl-alert-btn" data-bs-dismiss="modal">Ok</button>
      </div>
    </div>
  </div>
</div>
